module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-landing-page"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": "",
      "fill-height": "",
      "gap-20": "",
      "py-4": ""
    }
  }, [_c('div', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-start": "",
      "row": "",
      "gap-20": ""
    }
  }, [_c('div', {
    staticClass: "black--text text-16 font-weight-500"
  }, [_vm._v("Join Newsletter")]), _vm._v(" "), _c('div', {
    staticClass: "input-email bg-white"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "mx-4 font-poppins text-16 font-weight-500",
    attrs: {
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "tex-16 font-poppins font-weight-600",
    attrs: {
      "color": "black",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.storeEmail()
      }
    }
  }, [_vm._v("\n            Send!\n          ")])], 1)])], 1), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "gap-20": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/@yousoundapp"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/youtube.svg",
      "aspect-ratio": "1",
      "height": "32",
      "width": "32"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/yousoundapp/"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/instagram.svg",
      "aspect-ratio": "1",
      "height": "32",
      "width": "32"
    }
  })])])])], 1)]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": "",
      "fill-height": "",
      "gap-20": "",
      "py-4": ""
    }
  }, [_c('div', [_c('a', {
    staticClass: "text-grey-black-2 text-14",
    attrs: {
      "href": "/terms#privacy_policy",
      "target": "_blank"
    }
  }, [_vm._v("\n        Privacy Policy\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "text-grey-black-2 text-14 ml-3",
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("\n        Terms of Use\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-grey-black-1 text-12 font-weight-500"
  }, [_vm._v("© 2024 YouSound, Inc.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a89604fc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landing-new/components/FooterLandingPage.vue
// module id = 1834
// module chunks = 180